import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
//import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    marginTop: '23px',
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
  menuItem:{
    paddingTop: '10px',
    paddingBottom: '10px'
  }
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

class MultipleSelect extends React.Component {
  state = {
    connect: this.props.defaultValue || [],
  };

  handleChange = event => {
    const processed = [];
    if(event.target.value !== undefined)
    {
      processed.push(event.target.value);
    }
    this.setState({ connect: processed });
    event.target.id = this.props.id;
    event.target.name = this.props.name;
    this.props.onChange(event);
  };

  render() {
    const { classes, t /* theme */ } = this.props;
    return (
      <div className={classes.root}>
        <FormControl className={classes.formControl} fullWidth>
          <InputLabel htmlFor="select-multiple-chip" style={{ marginLeft: '-1rem' }}>{t("Accounts.Connect.SelectType")}</InputLabel>
          <Select
            readOnly={this.props.readOnly}
            multiple={false}
            value={this.state.connect}
            onChange={this.handleChange}
            input={<Input id="select-multiple-chip" />}
            renderValue={selected => (
              <div className={classes.chips}>
                {selected.map(value => (
                  <Chip key={value.id} label={value.name} className={classes.chip} />
                ))}
              </div>
            )}
            MenuProps={MenuProps}
            className={this.props.className}
          >
            {this.props.lookup !== undefined && this.props.lookup.map(item => (
                <MenuItem key={item.id} value={item} className={classes.menuItem}>
                    {/* <Checkbox checked={this.state.connect.map(x => x.id).indexOf(item.id) > -1 } /> */}
                    <ListItemText primary={item.name} />
                </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    );
  }
}

MultipleSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(withTranslation()(MultipleSelect));



// WEBPACK FOOTER //
// ./src/components/common/MultipleConnection.js